// Rendered around <main> children only when offline mode is enabled.
// While the backend is unreachable, routes outside the offline allowlist
// show a standard "Not available offline" page instead of a blank or
// errored screen. Connectivity hysteresis (two probe failures to flip)
// prevents pages flapping in and out on a slow link.

import { useLocation } from 'react-router-dom';
import { useConnectivity } from '@/hooks/useConnectivity';
import { isRouteAvailableOffline } from '@/services/offline/offlineCapabilities';
import OfflineUnavailablePage from './OfflineUnavailablePage';

export default function OfflineRouteGuard({ children }) {
  const location = useLocation();
  const { isOnline } = useConnectivity();

  if (!isOnline && !isRouteAvailableOffline(location.pathname)) {
    return <OfflineUnavailablePage />;
  }

  return children;
}
